<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-autocomplete
            v-model="cardTags"
            :items="tags"
            item-text="title"
            return-object
            hide-selected
            chips
            label="Слова для поиска"
            multiple
    >
        <template v-slot:selection="data">
            <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click:close="removeTag(data.index)"
            >
                {{ data.item.title }}
            </v-chip>
        </template>
    </v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'CardTagBox',
    data() {
        return {
            cardTags: [],
            buttonSaveActive: false,
            loaded: false
        }
    },
    computed: {
        ...mapGetters({
            cardTagsInCard: 'cards/cardTagsInCard',
            tags: 'cards/tags',
            getTagById: 'cards/getTagById'
        })
    },
    methods: {
        removeTag(index) {
            this.cardTags.splice(index, 1)
        }
    },
    watch: {
        cardTagsInCard(value) {
            this.loaded = false
            this.buttonSaveActive = false
            let cardTags = this._.cloneDeep(value)
            this.cardTags = []
            cardTags.forEach((item, i) => {
                let index = this.tags.findIndex(tag => tag.id === item.tag_id)
                this.cardTags.push(this.tags[index])
                if (i === cardTags.length - 1) {
                    this.loaded = true
                }
            })
        },
        cardTags(value) {
            if (this.loaded) {
                this.buttonSaveActive = true
                this.$emit('cardTagsChange', value)
            }
        }
    }
}
</script>

<style scoped>

</style>
